export const PAYROLL_RUN_OR_VOID_LEDGER_ENTRY_TYPE_VALUES = ["payroll_run", "payroll_void"] as const;

export type PayrollRunOrVoidLedgerEntryType = (typeof PAYROLL_RUN_OR_VOID_LEDGER_ENTRY_TYPE_VALUES)[number];

export const PAYROLL_RELATED_LEDGER_ENTRY_TYPE_VALUES = [
  ...PAYROLL_RUN_OR_VOID_LEDGER_ENTRY_TYPE_VALUES,
  "payroll_net_pay_failure_refund",
] as const;

export type PayrollRelatedLedgerEntryType = (typeof PAYROLL_RELATED_LEDGER_ENTRY_TYPE_VALUES)[number];

export const SPEND_MANAGEMENT_RELATED_LEDGER_ENTRY_TYPE_VALUES = [
  "bill_accrual",
  "bill_payment",
  "reimbursement_payout",
  "reimbursement_payment",
  "stripe_inbound_transfer",
  "card_transaction",
  "third_party_card_transaction",
] as const;

export type SpendManagementRelatedLedgerEntryType =
  (typeof SPEND_MANAGEMENT_RELATED_LEDGER_ENTRY_TYPE_VALUES)[number];

export const INVOICE_LEDGER_ENTRY_TYPE_VALUES = [
  "invoice_opened",
  "invoice_void",
  "invoice_payment",
  "invoice_write_off",
  "invoice_customer_credit_applied",
] as const;

export type InvoiceLedgerEntryType = (typeof INVOICE_LEDGER_ENTRY_TYPE_VALUES)[number];

export const LEDGER_ENTRY_TYPE_VALUES = [
  ...PAYROLL_RELATED_LEDGER_ENTRY_TYPE_VALUES,
  ...SPEND_MANAGEMENT_RELATED_LEDGER_ENTRY_TYPE_VALUES,
  ...INVOICE_LEDGER_ENTRY_TYPE_VALUES,
  "manual",
  "imported",
  "timesheet_recoding",
  "equipment_timesheet",
  "material_log",
] as const;

export type LedgerEntryType = (typeof LEDGER_ENTRY_TYPE_VALUES)[number];

// QuickBooks and Xero sync doesn't support these types (recodes would alter already-synced payroll), so they only post in Miter.
export const LEDGER_ENTRY_TYPES_NOT_SYNCED_TO_QB_OR_XERO: LedgerEntryType[] = [
  "timesheet_recoding",
  "manual",
  "material_log",
];
